import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {FullLayoutComponent} from './core/containers/full-layout/full-layout.component';
import {SimpleLayoutComponent} from './core/containers/simple-layout/simple-layout.component';
import {AuthGuardService} from './core/service/auth-guard.service';
import {APP_ROUTES} from './app.routes';
import {LoginComponent} from './core/components/login/login.component';
import {AutoLoginComponent} from './core/components/auto-login/auto-login.component';
import {EmailRecoverPasswordComponent} from './core/components/email-recover-password/email-recover-password.component';
import {ChangePasswordComponent} from './core/components/change-password/change-password.component';

export const routes: Routes = [
    {
        path: '',
        component: FullLayoutComponent,
        data: {
            title: 'Home'
        },
        canActivate: [AuthGuardService],
        children: APP_ROUTES
    },
    {
        path: 'pages',
        component: SimpleLayoutComponent,
        data: {
            title: 'Pages'
        },
        children: [
            {
                path: 'login',
                component: LoginComponent,
            },
            {
                path: 'auto-login',
                component: AutoLoginComponent
            },
            {
                path: 'email-recover-password',
                component: EmailRecoverPasswordComponent
            },
            {
                path: 'new-password',
                component: ChangePasswordComponent
            }
        ]
    },
    { path: '',   redirectTo: '/pages/login', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/app.routing.ts